"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountIntegrationsSchema = exports.GoogleSheetIntegrationSchema = exports.GoogleSheetsSyncSchema = exports.CalendarIntegrationSchema = exports.GcalSchema = void 0;
const zod_1 = require("zod");
const google_sheet_schema_1 = require("./google-sheet-schema");
const CalendarSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    accessRole: zod_1.z.enum(["owner", "writer", "reader", "freeBusyReader"]),
    primary: zod_1.z.boolean().optional(),
    summary: zod_1.z.string(),
})
    .passthrough(); // We don't know what else we need downstream, just pass everything
exports.GcalSchema = zod_1.z
    .object({
    calendars: CalendarSchema.array(),
})
    .passthrough(); // We don't know what else we need downstream, just pass everything
exports.CalendarIntegrationSchema = zod_1.z.object({
    gcal: exports.GcalSchema,
    gcalServerToken: zod_1.z.any(),
});
exports.GoogleSheetsSyncSchema = zod_1.z.object({
    start: zod_1.z.date().optional(),
    end: zod_1.z.date().optional(),
    lastError: zod_1.z.string().nullable().optional(),
    partialSync: zod_1.z.boolean().optional(), // Indicate if the sync was partial
});
exports.GoogleSheetIntegrationSchema = zod_1.z
    .object({
    organizationId: zod_1.z.string(),
    sheetId: zod_1.z.string().nullable(),
    token: zod_1.z.any(),
    syncStatus: zod_1.z
        .record(google_sheet_schema_1.GoogleSheetNamesEnum, exports.GoogleSheetsSyncSchema)
        .nullable(),
})
    .passthrough(); // We don't know what else we need downstream, just pass everything
exports.AccountIntegrationsSchema = zod_1.z.object({
    calendars: zod_1.z.array(exports.CalendarIntegrationSchema).optional(),
    emails: zod_1.z.any().optional(),
    sheets: zod_1.z.record(zod_1.z.string(), exports.GoogleSheetIntegrationSchema).optional(),
});
//# sourceMappingURL=account-integrations.js.map